<a class="btn btn-primary btn-stretch" href="{{ component.data.src }}" target="_blank" (click)="onDownloadPressed()"
  (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (focus)="onFocus()" (blur)="onBlur()"
  (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()"><i class="bx bx-download"
    *ngIf="component.data.showIcon"></i>
  {{ statesService.getComponentState(component) ? statesService.getComponentState(component).data.text : component.data.text }}</a>